// extracted by mini-css-extract-plugin
export default {"buttons":"Years_buttons__kVNVv","blocks":"Years_blocks__-HFT8","mAin":"Years_mAin__x1BdO","yearbutton":"Years_yearbutton__FFP2s"};